import React from 'react';
import RLSkeleton, { SkeletonProps as RLSkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonProps extends RLSkeletonProps {}

const Skeleton = (props: SkeletonProps) => {
  return <RLSkeleton {...props} />;
};

export default Skeleton;
